// One backend for admin, public invitations and live reactions.
export const API_BASE = (
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_ADMIN_API_URL ||
  process.env.REACT_APP_PREMIERE_API_URL ||
  ""
).replace(/\/$/, "");
